ltLazyLoad(function () {
  $('.lt-featured-collections, .lt-womens-nav').each(function () {
    const collections = $(this);
    if(!collections) return
    const flky = $(this).find('.img-wrapper.flickityt4s').data('flickityt4s');
    flky && flky.on('change', function () {
      const el = collections.find('tabs-nav').get(0);
      if (!el) return;
      const btn = el.buttons[this.selectedIndex];
      el.selectButton(btn);
    });
    $(this)
      .find('.slider-tabs .tabs-nav__item')
      .on('click', function () {
        const index = $(this).index();
        flky.select(index);
      });
  });
});